// Phase 4 strings: analytics.
const analyticsEn = {
  analytics: {
    nav: "Analytics",
    title: "Analytics",
    orgTitle: "Analytics — all projects",
    orgIntro: "Testing and production bugs across every project you can see.",
    projectIntro: "How testing is going and what escapes to production, for this project.",
    loading: "Loading analytics…",
    refreshing: "Updating…",
    period: {
      label: "Period",
      p30d: "30 days",
      p90d: "90 days",
      p6m: "6 months",
      p12m: "12 months",
      custom: "Custom",
      from: "From",
      to: "To",
      apply: "Apply",
      range: "{{from}} – {{to}}",
      invalid: "The start date must be before the end date.",
    },
    export: {
      bugs: "Export bugs CSV",
      tasks: "Export tasks CSV",
    },
    units: { d: "d", h: "h", m: "m" },
    insights: {
      title: "Insights",
      none: "Nothing stands out in this period yet. Insights appear once there are finished rounds and analysed bugs.",
      good: "Good",
      warning: "Worth a look",
      bad: "Needs attention",
      fpyUp: "First-pass yield rose to {{value}} (was {{previous}} in the previous period).",
      fpyDown: "First-pass yield fell to {{value}} (was {{previous}} in the previous period).",
      fpySame: "First-pass yield is steady at {{value}}.",
      fpyOnly: "First-pass yield is {{value}}.",
      testingGap: "{{value}} of analysed bugs ({{n}}) should have been caught by testing.",
      testingGapWhere: "{{value}} of analysed bugs ({{n}}) should have been caught by testing — most in {{label}}.",
      topRootCause: "Top root cause: {{label}} ({{value}} of categorised bugs).",
      slowMitigationBad: "{{label}} bugs met the mitigation target only {{value}} of the time.",
      slowMitigationGood: "{{label}} bugs met the mitigation target {{value}} of the time.",
      overdueActions: "Overdue action items: {{n}}.",
      recurring: "Bugs that came back after being closed: {{n}} (recurrence rate {{value}}).",
      hotspot: "Most failures are in cases tagged “{{label}}” ({{n}}).",
    },
    testing: {
      title: "Testing",
      tasksTested: "Tasks tested",
      roundsFinished: "Rounds finished: {{n}}",
      firstPassYield: "First-pass yield",
      fpyHint: "Round 1 with no failures · {{n}} first rounds",
      avgRounds: "Rounds to pass",
      avgRoundsHint: "Average · {{n}} needed 3 or more",
      medianToPass: "Time to pass",
      medianHint: "Median, ready for test → passed",
      findings: "Findings",
      findingsHint: "Problems found outside the written cases",
      monthly: "Rounds and failures by month",
      rounds: "Rounds",
      failures: "Failed results",
      fpyMonthly: "First-pass yield by month",
      byTag: "Failures by tag",
      bySection: "Failures by section",
      noFailures: "No failed results in this period.",
      slowest: "Slowest to pass",
      slowestEmpty: "No task passed in this period.",
      task: "Task",
      time: "Time",
      roundsCol: "Rounds",
      testers: "Testers",
      tester: "Tester",
      results: "Results",
      problems: "Problems found",
      testersEmpty: "No results recorded in this period.",
      empty: "No testing in this period",
      emptyBody: "Once testers finish rounds, you'll see first-pass yield, rounds to pass, failure hotspots and the slowest tasks here.",
    },
    bugs: {
      title: "Production bugs",
      total: "Bugs reported",
      openNow: "Open now",
      recurrence: "Recurrence rate",
      recurrenceHint: "Bugs that came back: {{n}}",
      actions: "Action items",
      actionsValue: "{{open}} open · {{overdue}} overdue",
      onTime: "Done on time",
      onTimeHint: "Completed in the period: {{n}}",
      monthly: "Bugs by month and severity",
      bySeverity: "By severity",
      rootCauses: "Root causes",
      escapePoints: "Where they should have been caught",
      escapeHint: "Highlighted: the two testing stages.",
      gap: "Testing gap",
      gapIntro: "Bugs that testing should have caught.",
      gapShare: "of bugs with an escape point",
      gapMissing: "No test case covered it",
      gapMissed: "A case existed but testing missed it",
      gapByComponent: "By component",
      gapNone: "No bug in this period was traced back to testing.",
      timings: "Response times by severity",
      severity: "Severity",
      count: "Bugs",
      ack: "Acknowledge",
      mitigate: "Mitigate",
      fix: "Fix",
      target: "Target",
      withinTarget: "Within target",
      noTarget: "No target",
      seenByVersion: "Bugs seen by version",
      seenByVersionHint: "Each bug counts once per version, by when it was seen in this period.",
      firstSeenByVersion: "Bugs first seen by version",
      firstSeenByVersionHint: "Where each bug first showed up on an app, if that was in this period.",
      byComponent: "By component",
      none: "None in this period.",
      unknown: "Not set",
      empty: "No production bugs in this period",
      emptyBody: "When bugs are reported, you'll see them by severity and month, their root causes, where they escaped, and how fast they were handled.",
    },
    projects: {
      title: "Projects",
      project: "Project",
      tasksTested: "Tasks tested",
      fpy: "First-pass yield",
      bugs: "Bugs",
      open: "Open",
      major: "S1 + S2",
      gap: "Testing gap",
      overdue: "Overdue actions",
      sortBy: "Sort by {{column}}",
      empty: "You're not a member of any project yet.",
    },
  },
};

export default analyticsEn;

type Shape<T> = { [K in keyof T]: T[K] extends string ? string : Shape<T[K]> };
export type AnalyticsTranslation = Shape<typeof analyticsEn>;
